import { HARD_REDIRECT_TRIGGERED, SCROLL_TO } from 'actions/window';

// action effects that relate to the window.
export default function windowMiddleware(window) {
  return () => next => action => {
    switch (action.type) {
      case HARD_REDIRECT_TRIGGERED:
        window.location = action.url;
        break;
      case SCROLL_TO:
        window.scrollTo(...action.payload);
        break;
      default:
        break;
    }

    next(action);
  };
}



// WEBPACK FOOTER //
// ./src/middleware/window.js